import { useQuery } from "react-query";
import queryString from "query-string";
import URL from "core/resources/urls";
import http from "infra/http";

function useGetMatrizOperacoes(
  talhaoIds: string[],
  unidadeId?: string,
  safraPeriodoId?: string,
  operacao?: string,
  classeOperacao?: string[],
) {
  const talhaoIdsKey = [...talhaoIds].sort();

  return useQuery(
    [URL.ORDEM_SERVICO.TALHOES, talhaoIdsKey, unidadeId, safraPeriodoId, operacao, classeOperacao],
    async () => {
      const { data } = await http.get(URL.ORDEM_SERVICO.TALHOES, {
        params: {
          talhaoIds,
          unidadeId,
          safraPeriodoId,
          operacaoIds: operacao ? [operacao] : undefined,
          operacaoClasseIds: classeOperacao,
        },
        paramsSerializer: params => queryString.stringify(params, { arrayFormat: "none" }),
      });
      return data;
    },
    {
      enabled: talhaoIds.length > 0,
    }
  );
}

export default useGetMatrizOperacoes;
